"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processUpdateSupplierOrderLine = void 0;
const uuid_1 = require("uuid");
const helpers_1 = require("../../helpers");
const sendEmail_1 = require("../sendEmail");
const addOrderLog_1 = require("./addOrderLog");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderById_1 = require("./getOrderById");
const getOrderLineTitle_1 = require("./getOrderLineTitle");
async function processUpdateSupplierOrderLine(supabase, updateRequest) {
    const { data, error } = await supabase
        .from("order_lines")
        .select("*, versions:order_line_versions!order_line_id(*)")
        .eq("id", updateRequest.orderLineId)
        .single();
    if (error) {
        throw new Error(error.message);
    }
    const orderLine = data;
    const order = await (0, getOrderById_1.getOrderById)(supabase, orderLine.order_id);
    if (!orderLine.versions) {
        throw new Error("No versions found for order line");
    }
    const latestVersion = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(orderLine.versions);
    if (!latestVersion) {
        throw new Error("No versions found for order line");
    }
    switch (updateRequest.type) {
        case "GOLF": {
            const config = latestVersion.config;
            let course_name = "";
            if (config.course.name) {
                course_name = config.course.name.en;
            }
            if (updateRequest.action !== helpers_1.OrderLineStatus.REJECTED_BY_SUPPLIER) {
                const update = updateRequest.value;
                await (0, addOrderLog_1.addOrderLog)(supabase, {
                    created_by: order.client?.id,
                    type: "Update",
                    order_id: order.id,
                    detail: {
                        message: `Tee Time at ${course_name} ${updateRequest.action} by: ${update.updated_by} at ${config.supplier.name}`,
                    },
                });
                for (const [index, group] of config.tee_time.groups.entries()) {
                    const updateTime = update.tee_times[index];
                    if (updateTime) {
                        group.start_time = updateTime;
                    }
                }
                config.tee_time.updated_by = update.updated_by;
                config.tee_time.updated_at = update.updated_at;
                if (update.hole_option) {
                    config.hole_options.selected_option = update.hole_option;
                }
                latestVersion.config = config;
            }
            else {
                const update = updateRequest.value;
                latestVersion.rejection_date = new Date();
                latestVersion.rejection_reason = {
                    type: update.rejection.type,
                    reason: update.rejection.reason,
                    rejected_by: update.rejection.rejected_by,
                };
                await (0, addOrderLog_1.addOrderLog)(supabase, {
                    created_by: order.client?.id,
                    type: "Update",
                    order_id: order.id,
                    detail: {
                        message: `Tee Time at ${course_name} rejected by: ${update.rejection.rejected_by} at ${config.supplier.name} (Reason: ${update.rejection.reason})`,
                    },
                });
            }
            break;
        }
        case "TRANSFER": {
            const config = latestVersion.config;
            if (updateRequest.action === helpers_1.OrderLineStatus.CONFIRMED) {
                const update = updateRequest.value;
                await (0, addOrderLog_1.addOrderLog)(supabase, {
                    created_by: order.client?.id,
                    type: "Update",
                    order_id: order.id,
                    detail: {
                        message: `Transfer Details Updated - (${update.name && `Name: ${update.name}`} ${update.pickup_time && `Pick-up Time: ${update.pickup_time}`} )`,
                    },
                });
                config.driver = {
                    name: update.name,
                    phone: update.phone,
                    pickup_time: update.pickup_time,
                    updated_by: update.updated_by,
                    updated_at: update.updated_at,
                };
                latestVersion.config = config;
            }
            else {
                const update = updateRequest.value;
                latestVersion.rejection_date = new Date();
                latestVersion.rejection_reason = {
                    type: update.rejection.type,
                    reason: update.rejection.reason,
                    rejected_by: update.rejection.rejected_by,
                };
                await (0, addOrderLog_1.addOrderLog)(supabase, {
                    created_by: order.client?.id,
                    type: "Update",
                    order_id: order.id,
                    detail: {
                        message: `Transfer rejected by: ${update.rejection.rejected_by} at ${config.supplier.name} (Reason: ${update.rejection.reason})`,
                    },
                });
            }
            break;
        }
        case "HOTEL": {
            const config = latestVersion.config;
            if (updateRequest.action === helpers_1.OrderLineStatus.CONFIRMED) {
                const update = updateRequest.value;
                await (0, addOrderLog_1.addOrderLog)(supabase, {
                    created_by: order.client?.id,
                    type: "Update",
                    order_id: order.id,
                    detail: {
                        message: `Hotel #${update.confirmation_number} confirmed by: ${update.updated_by} at ${config.supplier.name}`,
                    },
                });
                config.confirmation_number = update.confirmation_number;
                config.updated_by = update.updated_by;
                config.updated_at = update.updated_at;
                latestVersion.config = config;
            }
            else {
                const update = updateRequest.value;
                latestVersion.rejection_date = new Date();
                latestVersion.rejection_reason = {
                    type: update.rejection.type,
                    reason: update.rejection.reason,
                    rejected_by: update.rejection.rejected_by,
                };
                await (0, addOrderLog_1.addOrderLog)(supabase, {
                    created_by: order.client?.id,
                    type: "Update",
                    order_id: order.id,
                    detail: {
                        message: `Hotel rejected by: ${update.rejection.rejected_by} at ${config.supplier.name} (Reason: ${update.rejection.reason})`,
                    },
                });
            }
            break;
        }
        case "EXCURSION": {
            const config = latestVersion.config;
            if (updateRequest.action === helpers_1.OrderLineStatus.CONFIRMED) {
                const update = updateRequest.value;
                await (0, addOrderLog_1.addOrderLog)(supabase, {
                    created_by: order.client?.id,
                    type: "Update",
                    order_id: order.id,
                    detail: {
                        message: `Excursion confirmed by: ${update.updated_by} at ${config.supplier.name}`,
                    },
                });
                config.updated_by = update.updated_by;
                config.updated_at = update.updated_at;
                latestVersion.config = config;
            }
            else {
                const update = updateRequest.value;
                latestVersion.rejection_date = new Date();
                latestVersion.rejection_reason = {
                    type: update.rejection.type,
                    reason: update.rejection.reason,
                    rejected_by: update.rejection.rejected_by,
                };
                await (0, addOrderLog_1.addOrderLog)(supabase, {
                    created_by: order.client?.id,
                    type: "Update",
                    order_id: order.id,
                    detail: {
                        message: `Excursion rejected by: ${update.rejection.rejected_by} at ${config.supplier.name} (Reason: ${update.rejection.reason})`,
                    },
                });
            }
            break;
        }
        case "CUSTOM": {
            const config = latestVersion.config;
            if (updateRequest.action === helpers_1.OrderLineStatus.CONFIRMED) {
                const update = updateRequest.value;
                await (0, addOrderLog_1.addOrderLog)(supabase, {
                    created_by: order.client?.id,
                    type: "Update",
                    order_id: order.id,
                    detail: {
                        message: `Custom confirmed by: ${update.updated_by} at ${config.supplier.name}`,
                    },
                });
                config.updated_by = update.updated_by;
                config.updated_at = update.updated_at;
                latestVersion.config = config;
            }
            else {
                const update = updateRequest.value;
                latestVersion.rejection_date = new Date();
                latestVersion.rejection_reason = {
                    type: update.rejection.type,
                    reason: update.rejection.reason,
                    rejected_by: update.rejection.rejected_by,
                };
                await (0, addOrderLog_1.addOrderLog)(supabase, {
                    created_by: order.client?.id,
                    type: "Update",
                    order_id: order.id,
                    detail: {
                        message: `Custom rejected by: ${update.rejection.rejected_by} at ${config.supplier.name} (Reason: ${update.rejection.reason})`,
                    },
                });
            }
            break;
        }
    }
    latestVersion.id = (0, uuid_1.v4)();
    latestVersion.created_at = new Date();
    latestVersion.created_by = helpers_1.ADMIN_USER_ID;
    latestVersion.status = updateRequest.action;
    const { error: versionError } = await supabase
        .from("order_line_versions")
        .insert([latestVersion]);
    if (!error && !versionError) {
        await (0, addOrderLog_1.addOrderLog)(supabase, {
            type: "Update",
            order_id: orderLine.order_id,
            detail: {
                message: `Order Line Updated - ${(0, getOrderLineTitle_1.getOrderLineTitle)(orderLine)} - (${updateRequest.action})`,
            },
        });
        if (updateRequest.action === helpers_1.OrderLineStatus.CONFIRMED) {
            let emailTemplateId = null;
            // If confirmed and golf line send confirmation email to GOLF supplier.
            if (updateRequest.type === "GOLF") {
                emailTemplateId = helpers_1.GOLF_LINE_BOOKING_CONFIRMATION_SUPPLIER;
            }
            if (updateRequest.type === "TRANSFER") {
                emailTemplateId = helpers_1.TRANSFER_LINE_BOOKING_CONFIRMATION_SUPPLIER;
            }
            if (emailTemplateId) {
                const email_obj = {
                    language_code: "en",
                    template_id: emailTemplateId,
                    order_line_id: orderLine.id,
                    order_id: order.id,
                };
                await (0, sendEmail_1.sendEmail)(email_obj);
            }
        }
        return {
            success: true,
            data: latestVersion,
        };
    }
    if (versionError) {
        console.log("ERORR", versionError.message);
        throw new Error(versionError.message);
    }
}
exports.processUpdateSupplierOrderLine = processUpdateSupplierOrderLine;
